package app.nestbridge.feature.children.model

import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class Child(
    val id: String,
    val fullName: String,
    val displayName: String? = null,
    val dateOfBirth: LocalDate,
    val primaryLanguages: List<String> = emptyList(),
    val stewardUserIds: List<String> = emptyList(),
    val profilePictureUrl: String? = null,
    val status: ChildStatus,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
) {
    val effectiveDisplayName: String
        get() = displayName ?: fullName

    val formatedDateOfBirth: String
        get() = "${dateOfBirth.month.name.lowercase().replaceFirstChar { it.uppercase() }} " +
                "${dateOfBirth.day}, ${dateOfBirth.year}"

    companion object {
        val empty = Child(
            id = "",
            fullName = "",
            displayName = null,
            dateOfBirth = LocalDate(2000, 1, 1),
            primaryLanguages = emptyList(),
            stewardUserIds = emptyList(),
            profilePictureUrl = null,
            status = ChildStatus.Active,
            createdAt = kotlin.time.Clock.System.now(),
            createdBy = "",
            modifiedAt = kotlin.time.Clock.System.now(),
            modifiedBy = "",
        )
    }
}

@Serializable
enum class ChildStatus {
    Active,
    Suspended,
    Archived
}
